import { useContext } from 'react'
import { UserContext } from '@/app/UserContext'
import { formatSiteTime, type SiteTimeOptions } from './userTime'

/**
 * The viewer's chosen time zone, or '' when they have no preference (the
 * overwhelming majority — see the opt-in rule in
 * docs/superpowers/specs/2026-07-28-user-timezone-opt-in-design.md).
 *
 * '' is a meaningful value, not a missing one: it means "render in the site's
 * Eastern default", which is what the site has always done.
 */
export function useUserTimeZone(): string {
  const { user } = useContext(UserContext)
  return user?.settings?.timeZone ?? ''
}

/**
 * Bound formatter for real-world timestamps: same contract as `formatSiteTime`
 * but with the viewer's zone already applied.
 *
 * NOT for sim dates — those are the in-game calendar and belong to `fmtSimDate`,
 * which is deliberately timezone-stable.
 */
export function useSiteTime(): (
  value: string | Date | null | undefined,
  opts?: SiteTimeOptions,
) => string {
  const tz = useUserTimeZone()
  return (value, opts) => formatSiteTime(value, tz, opts)
}
